// extracted by mini-css-extract-plugin
export default {"body":"body___s1zNS"};